var city =
{
    "citycode": "1852",
    "adcode": "810000",
    "name": "香港特别行政区",
    "center": {
        "lng": 114.171203,
        "lat": 22.277468
    },
    "districtList": [
        {
            "citycode": "1852",
            "adcode": "810013",
            "name": "北区",
            "center": {
                "lng": 114.147364,
                "lat": 22.496104
            }
        },
        {
            "citycode": "1852",
            "adcode": "810015",
            "name": "西贡区",
            "center": {
                "lng": 114.264645,
                "lat": 22.314213
            }
        },
        {
            "citycode": "1852",
            "adcode": "810014",
            "name": "大埔区",
            "center": {
                "lng": 114.171743,
                "lat": 22.445653
            }
        },
        {
            "citycode": "1852",
            "adcode": "810011",
            "name": "屯门区",
            "center": {
                "lng": 113.976574,
                "lat": 22.393844
            }
        },
        {
            "citycode": "1852",
            "adcode": "810016",
            "name": "沙田区",
            "center": {
                "lng": 114.195365,
                "lat": 22.379532
            }
        },
        {
            "citycode": "1852",
            "adcode": "810008",
            "name": "黄大仙区",
            "center": {
                "lng": 114.203886,
                "lat": 22.336321
            }
        },
        {
            "citycode": "1852",
            "adcode": "810003",
            "name": "东区",
            "center": {
                "lng": 114.226003,
                "lat": 22.279693
            }
        },
        {
            "citycode": "1852",
            "adcode": "810009",
            "name": "观塘区",
            "center": {
                "lng": 114.214054,
                "lat": 22.320838
            }
        },
        {
            "citycode": "1852",
            "adcode": "810018",
            "name": "离岛区",
            "center": {
                "lng": 113.94612,
                "lat": 22.286408
            }
        },
        {
            "citycode": "1852",
            "adcode": "810004",
            "name": "南区",
            "center": {
                "lng": 114.160012,
                "lat": 22.245897
            }
        },
        {
            "citycode": "1852",
            "adcode": "810001",
            "name": "中西区",
            "center": {
                "lng": 114.154373,
                "lat": 22.281981
            }
        },
        {
            "citycode": "1852",
            "adcode": "810007",
            "name": "九龙城区",
            "center": {
                "lng": 114.192847,
                "lat": 22.31251
            }
        },
        {
            "citycode": "1852",
            "adcode": "810006",
            "name": "深水埗区",
            "center": {
                "lng": 114.163242,
                "lat": 22.333854
            }
        },
        {
            "citycode": "1852",
            "adcode": "810005",
            "name": "油尖旺区",
            "center": {
                "lng": 114.173332,
                "lat": 22.311704
            }
        },
        {
            "citycode": "1852",
            "adcode": "810002",
            "name": "湾仔区",
            "center": {
                "lng": 114.182915,
                "lat": 22.276389
            }
        },
        {
            "citycode": "1852",
            "adcode": "810012",
            "name": "元朗区",
            "center": {
                "lng": 114.032438,
                "lat": 22.441428
            }
        },
        {
            "citycode": "1852",
            "adcode": "810010",
            "name": "荃湾区",
            "center": {
                "lng": 114.121079,
                "lat": 22.368307
            }
        },
        {
            "citycode": "1852",
            "adcode": "810017",
            "name": "葵青区",
            "center": {
                "lng": 114.139319,
                "lat": 22.363877
            }
        }
    ]
}

export default city;


// WEBPACK FOOTER //
// ./src/util/province/hk.js